import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TooltipService } from '../../services/tooltip.service';
import { CdkPortal } from '@angular/cdk/portal';

@Component({
  selector: 'sc-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent
  implements AfterViewInit, OnDestroy, OnChanges, AfterViewChecked {
  @Input() element;
  @Input() fullScreenOnMobile: boolean;
  @Input() overlay: boolean;

  @ViewChild(CdkPortal, { static: true }) portal;
  @ViewChild('tooltip', { static: false }) tooltip;

  top: number;
  left: number;
  bottom: number;
  right: number;

  arrowX: number;
  arrowY: number;

  constructor(private tooltipService: TooltipService) {}

  ngAfterViewInit() {
    if (this.fullScreenOnMobile) {
      document.body.classList.add(`disable-scroll-md-down`);
    }

    setTimeout(() => {
      this.tooltipService.setPortal(this.portal);
    });
  }

  ngAfterViewChecked() {
    this.updateCoords();
  }

  ngOnDestroy() {
    document.body.classList.remove(`disable-scroll-md-down`);
    this.tooltipService.setPortal(undefined);
  }

  ngOnChanges(changes: SimpleChanges) {
    const element: SimpleChange = changes.element;
    if (element.previousValue !== element.currentValue) {
      this.updateCoords();
    }
  }

  @HostListener('window:resize')
  updateCoords() {
    if (!this.tooltip) {
      return;
    }

    const tooltipWidth = this.tooltip.nativeElement.offsetWidth;
    const body = document.body;

    const DESKTOP_SCREEN_BREAKPOINT = 992;

    if (
      this.fullScreenOnMobile &&
      body.offsetWidth <= DESKTOP_SCREEN_BREAKPOINT
    ) {
      this.top = 0;
      this.right = -tooltipWidth / 2;
      this.bottom = 0;
      this.left = tooltipWidth / 2;
      this.arrowX = null;
      this.arrowY = null;

      return;
    }

    const box = this.element.getBoundingClientRect();

    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft =
      window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;

    const top = box.top + box.height + scrollTop - clientTop;
    let left = box.left + box.width / 2 + scrollLeft - clientLeft;

    this.arrowX = Math.round(left);
    this.arrowY = Math.round(top);

    const MAX_LEFT = body.offsetWidth - tooltipWidth / 2;
    const MIN_LEFT = tooltipWidth / 2;

    if (left > MAX_LEFT) {
      left = MAX_LEFT;
    }

    if (left < MIN_LEFT) {
      left = MIN_LEFT;
    }

    this.left = Math.round(left);
    this.top = Math.round(top);
    this.right = null;
    this.bottom = null;
  }
}
